var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"Profile-view"},[_c('ProfileBody')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }